import { Container } from 'inversify';
import { DiContainerInjectFn } from './ts';
// @ts-ignore
import * as injectModules0 from '../agriculture/agriculture.di.ts'; import * as injectModules1 from '../auth/auth.di.ts'; import * as injectModules2 from '../bags/bags.di.ts'; import * as injectModules3 from '../common/common.di.ts'; import * as injectModules4 from '../mixing/mixing.di.ts'; import * as injectModules5 from '../warehouses/warehouses.di.ts'; var injectModules = [injectModules0, injectModules1, injectModules2, injectModules3, injectModules4, injectModules5];

// Иногда возникает ошибка в режиме разработки - 'No matching bindings found for serviceIdentifier:'. console.log исправляет обновление сервера
// console.log(injectModules);

const DiContainer = new Container();

Object.values(injectModules).forEach((module) => {
  // @ts-ignore
  (module.default as DiContainerInjectFn)(DiContainer);
});

export { DiContainer };
